// Reads an SSE chat stream and dispatches parsed events to callbacks.
const parseEvent = (part) => {
  const line = part.replace(/^data:\s*/, "");
  if (!line) return null;
  try {
    return JSON.parse(line);
  } catch {
    return null; // keep-alive / partial lines
  }
};

const dispatch = (evt, { onSession, onDelta, onError }) => {
  if (evt.session_id && onSession) onSession(evt.session_id);
  if (evt.delta) onDelta(evt.delta);
  if (evt.error && onError) onError(evt.error);
};

async function openStream(url, body) {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok || !res.body) {
    const errTxt = await res.text();
    throw new Error(errTxt || String(res.status));
  }
  return res.body.getReader();
}

export async function streamChat({ url, body, ...handlers }) {
  const reader = await openStream(url, body);
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    parts.map(parseEvent).filter(Boolean).forEach((evt) => dispatch(evt, handlers));
  }
}
